import { checkServiceProvider } from './serviceProviderConfig';

export const getConfig = ({
  i18n,
  insuracePortalUserRole,
  showAllUsers,
  showCompany,
  isMechanicUser
}) => ({
  tableColumns: [
    ...(insuracePortalUserRole && showCompany
      ? [
          {
            id: 'companyName',
            numeric: false,
            disablePadding: true,
            label: i18n.t('policyHolder'),
            needSorting: true
          }
        ]
      : []),
    {
      id: 'full_name',
      numeric: false,
      disablePadding: true,
      label: i18n.t('vehicles.fullName'),
      needSorting: true
    },
    ...(showAllUsers
      ? [
          {
            id: 'role',
            numeric: false,
            disablePadding: false,
            label: i18n.t('vehicles.role'),
            needSorting: false
          }
        ]
      : []),
    {
      id: 'email',
      numeric: false,
      disablePadding: false,
      label: i18n.t('vehicles.email'),
      needSorting: true
    },
    ...(!isMechanicUser &&
    !insuracePortalUserRole &&
    checkServiceProvider('config_empId', window.$environment.SERVICE_PROVIDER)
      ? [
          {
            id: 'empId',
            numeric: false,
            disablePadding: false,
            label: i18n.t('vehicles.empId'),
            needSorting: true
          }
        ]
      : []),
    {
      id: 'phone',
      numeric: false,
      disablePadding: false,
      label: i18n.t('common.phone'),
      needSorting: false
    },
    ...(!insuracePortalUserRole
      ? [
          {
            id: 'assigned_vehicles',
            numeric: false,
            disablePadding: false,
            label: i18n.t('vehicles.assignedVehicles'),
            needSorting: false
          }
        ]
      : []),
    {
      id: 'last_login',
      numeric: false,
      disablePadding: false,
      label: i18n.t('vehicles.lastLogin'),
      needSorting: true
    },
    {
      id: 'status',
      numeric: false,
      disablePadding: false,
      label: i18n.t('Status'),
      needSorting: true
    },
    ...(!insuracePortalUserRole
      ? [
          {
            id: 'eld',
            numeric: false,
            disablePadding: false,
            label: i18n.t('ELD'),
            needSorting: false
          }
        ]
      : []),
    {
      id: 'actions',
      label: i18n.t('Actions')
    }
  ]
});

export const getELDStatusIcon = (data) => {
  const statusMap = {
    NOT_STARTED: 'eld-inActive',
    TAMPERED: 'eld-inActive',
    DISCONNECTED: 'eld-inActive',
    CONNECTED: 'eld-active',
    '': 'eld-loggedOut'
  };

  return statusMap[data] || '';
};
